<template>
  <div class="company flex-row">
    <div class="poster">
      <img :src="detail.pictureUrl ? $imgUrl + detail.pictureUrl : require('../../assets/image/login/logo.png')"/>

    </div>
    <div class="info">
      <p class="name">{{ detail.name }}</p>
      <p style="display: flex;margin-top: 10px;">销量：{{ detail.num || '暂无' }}</p>
      <!--			<p style="display: flex;margin-top: 10px;">评分：{{detail.satisfactionRating || '暂无' }}</p>-->
      <p style="display: flex;margin-top: 10px;">评分：
        <el-rate :value="Number(detail.satisfactionRating)" disabled show-score text-color="#ff9900" score-template=""/>
        <span v-if=" detail.satisfactionRating == null" style="color: #ff9900;">未评分</span>
        <span v-else style="color: #ff9900; font-weight: bold;">{{ detail.satisfactionRating }} 分</span>
      </p>
      <p style="display: flex;margin-top: 10px;">台班费：{{ detail.price || '暂无' }}</p>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: ['detail'],
  data() {
    return {}
  },
  method: {},
  mounted() {
    console.log(this.detail)
  }
}
</script>

<style scoped lang="less">
.company {
  height: 0.91rem;
  cursor: pointer;

  .poster {
    width: 0.91rem;
    height: 0.91rem;
    margin-right: 0.26rem;
    line-height: 0;

    img {
      width: 100%;
      height: 100%;
      border-radius: 0.06rem 0.06rem 0.06rem 0.06rem;
    }
  }


  .info {
    flex: 1;
    font-size: .13rem;

    .name {
      font-size: 0.16rem;
      color: #000000;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      /* autoprefixer: off */
      -webkit-box-orient: vertical;
    }

    span {
      height: 30px;
    }
  }
}
</style>
